import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import times from 'lodash/times';
import React from 'react';

const Survey = ({ question }) => {
  const theme = useTheme();
  const color = theme.palette.primary.main;
  return (
    <>
      <Typography paragraph variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <Grid container spacing={2} columns={10}>
        {times(10).map((i) => (
          <Grid item sm={2} key={i}>
            <Box
              sx={{
                border: `1px solid ${color}`,
                width: 60,
                height: 60,
                borderRadius: '50%',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                color,
                fontSize: 20,
                fontWeight: 700,
              }}
            >
              {i + 1}
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Survey;
